import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AutoComplete from 'material-ui/AutoComplete';
import DatePicker from 'material-ui/DatePicker';
import TimePicker from 'material-ui/TimePicker';
import TextField from 'material-ui/TextField';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import FontIcon from 'material-ui/FontIcon';
import Paper from 'material-ui/Paper';
import ContentAdd from 'material-ui/svg-icons/content/add';
import moment from 'moment';

import {fetchRolesRoutine} from '../../routines';
import { customizedFuzzyFilter, toArray, sortStrings } from '../../utils/helper';
import { showError } from '../../actions/dialogs';

import styles from './styles';

const roleDSConfig = {
  text: 'name',
  value: 'id',
};

const combineDateTime = (date, time) => {
  const result = moment(date).startOf('d');
  const time2 = moment(time);
  result.hours(time2.hours());
  result.minutes(time2.minutes());
  return result.toDate();
};

class ResourceInput extends React.Component {
  static propTypes = {
    // initialDate: PropTypes.object,
    fetchRoles: PropTypes.func.isRequired,
    roles: PropTypes.array.isRequired,
    fixedDate: PropTypes.object,
    onAdd: PropTypes.func.isRequired,

    showError: PropTypes.func.isRequired,
  };

  state = {};

  // || this.props.initialDate
  componentWillMount() {
    this.props.fetchRoles();
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.fixedDate) {
      this.setState({
        date: nextProps.fixedDate,
      });
    }
  }

  handleAddResource = () => {
    console.log('handleAddResource', this.state);
    const { showError } = this.props;
    // TODO replace with form validation
    if (!this.state.date) {
      return showError('Validation Error', 'Please select a date');
    }
    if (!this.state.from) {
      return showError('Validation Error', 'Please select a start time');
    }
    if (!this.state.to) {
      return showError('Validation Error', 'Please select an end time');
    }
    // if (!this.state.quantity) {
    //   this.state.quantity = 1;
    // }
    if (!this.state.role) {
      return showError('Validation Error', 'Please select a role');
    }

    const from = combineDateTime(this.state.date, this.state.from).toISOString();
    let to = combineDateTime(this.state.date, this.state.to).toISOString();
    if (moment(to).isBefore(moment(from))) {
      to = moment(to).add(1, 'days').toDate().toISOString();
    }

    const data = {
      from,
      to,
      quantity: this.state.quantity || 1,
      role: this.state.role,
    };

    console.log('new resource', data);

    this.props.onAdd(data);
    // const newState = this.props.onReset(data);
    // console.log('newState', newState);
    // this.setState(newState);
    this.setState({
      quantity: '',
      role: '',
      // to: '',
      // from: '',
      // date: '',
    });

    this.refs.autoComplete.setState({ searchText: '' });

    return null;
  };

  handleUpdateInput = (a, b, c) => {
    console.log('handleUpdateInput', a, b, c);
  };

  handleSelectRole = (a, b, c) => {
    console.log('handleSelectRole', a, b, c);
  };

  render() {
    const { roles, fixedDate } = this.props;
    return (<Paper style={styles.row}>
      { !fixedDate ? <div style={styles.time}>
        <FontIcon className="material-icons" style={styles.icon} color="grey">date_range</FontIcon>
        <DatePicker
          style={styles.dateInput}
          mode="landscape"
          floatingLabelText="Date"
          floatingLabelFixed
          autoOk
          value={this.state.date || null}
          fullWidth
          onChange={(evt, date) => this.setState({ date })}
        />
      </div> : null }
      <div style={styles.time}>
        <FontIcon className="material-icons" style={styles.icon} color="grey">access_time</FontIcon>
        <TimePicker
          style={styles.timeInput}
          floatingLabelText="Start"
          floatingLabelFixed
          fullWidth
          value={this.state.from ? this.state.from : null}
          onChange={(evt, from) => this.setState({ from })}
          minutesStep={5}
        />
      </div>
      <div style={styles.time}>
        <FontIcon className="material-icons" style={styles.icon} color="grey">access_time</FontIcon>
        <TimePicker
          style={styles.timeInput}
          floatingLabelText="End"
          floatingLabelFixed
          fullWidth
          value={this.state.to ? this.state.to : null}
          onChange={(evt, to) => this.setState({ to })}
          minutesStep={5}
        />
      </div>
      <div style={styles.fixedInput}>
        <TextField
          name="quantity"
          floatingLabelText="Quantity"
          floatingLabelFixed
          value={this.state.quantity ? this.state.quantity : ''}
          style={styles.quantity}
          onChange={(evt, quantity) => this.setState({ quantity })}
        />
      </div>
      <div style={styles.input}>
        <AutoComplete
          name="role"
          style={styles.role}
          searchText={this.state.employee}
          dataSource={roles}
          ref="autoComplete"
          dataSourceConfig={roleDSConfig}
          filter={customizedFuzzyFilter}
          floatingLabelText="Role"
          floatingLabelFixed
          value={this.state.role ? this.state.role : ''}
          openOnFocus
          onUpdateInput={this.handleUpdateInput}
          onNewRequest={(role) => this.setState({ role })}
          fullWidth
        />
      </div>
      <div>
        <FloatingActionButton mini secondary onClick={this.handleAddResource}>
          <ContentAdd />
        </FloatingActionButton>
      </div>
    </Paper>);
  }
}

// const form = reduxForm({
//   form: 'ResourceInput',  // a unique identifier for this form
//   enableReinitialize: true,
// })(ResourceInput);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showError,
    fetchRoles: fetchRolesRoutine.trigger,
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    roles: toArray(state.get('roles').get('roles').toJS()).sort((a,b) => sortStrings(a.name, b.name)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourceInput);



// WEBPACK FOOTER //
// ./src/components/ResourceInput/index.js